import { TradableWallet } from "../../interfaces/tradable_wallet";
import { Address } from "../../address";
import { TYPE_NAME_INDEX } from "@helpers/constants";

export class IndexWallet extends TradableWallet {
	public static TypeName = TYPE_NAME_INDEX;

	public getAddresses(): Address[] {
		return [];
	}

	public setAddresses(addresses: Address[]): void {
		return;
	}

	public getBaseUrl(): string {
		return "/index-wallet/";
	}
}
